// Google Analytics Tracking with parent App

export const GAtrack = (data) => {
  if (!window.dataLayer) return;
  if (data) {
    // if (data.event === 'rbVideoTracking') {
    //   window.parent.dataLayer.dataLayer(data);
    // } else {
    window.dataLayer.push(data);
    // }
  }
};
